import { type FC, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useLinksAutocompleteQuery } from "@/partner/entities/links";

interface LinkOption {
  value: string;
  label: string;
}

interface LinksAutocompleteProps {
  label: string;
  value: string[];
  onChange: (linkIds: string[]) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

// Тот же приём, что и ProductsAutocomplete — управляемый мультиселект
// value/onChange (не react-final-form), используется в аналитическом
// <Filter> для разбивки Views/Sales по конкретной маркетинговой ссылке
// и в условии аудитории «ссылка регистрации».
export const LinksAutocomplete: FC<LinksAutocompleteProps> = ({
  label,
  value,
  onChange,
  disabled,
  error,
  helperText,
}) => {
  const [search, setSearch] = useState("");

  const { data, loading } = useLinksAutocompleteQuery({
    fetchPolicy: "cache-and-network",
    variables: { input: search || undefined, value },
  });

  const optionsById = new Map<string, LinkOption>();
  for (const option of data?.autocomplete?.options ?? []) {
    if (option) optionsById.set(option.value, option);
  }
  for (const option of data?.autocomplete?.value ?? []) {
    if (option) optionsById.set(option.value, option);
  }
  const options = Array.from(optionsById.values());

  return (
    <Autocomplete<LinkOption, true>
      multiple
      fullWidth
      filterOptions={(opts) => opts}
      loading={loading}
      disabled={disabled}
      options={options}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) =>
        option.value === selected.value
      }
      value={options.filter((option) => value.includes(option.value))}
      onInputChange={(_event, newInputValue, reason) => {
        setSearch(reason === "reset" ? "" : newInputValue);
      }}
      onChange={(_event, newValue) => {
        onChange(newValue.map((option) => option.value));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};
